import { Component } from '@grafikr/components';

export default Component(() => {});
